// extracted by mini-css-extract-plugin
export default {"WebsiteBody":"Website_body_WebsiteBody__BA6Ny"};